export const productFields = [
  {
    label: 'Uniprot ID',
    valueKey: 'metadata.uniprotId',
    linkPrefix: 'https://www.uniprot.org/uniprotkb/',
    linkSuffix: '/entry',
    condition: (tab, product) => tab && !!product?.metadata?.uniprotId,
  },
  {
    label: 'Gene ID',
    valueKey: 'metadata.geneId',
    linkPrefix: 'https://www.ncbi.nlm.nih.gov/gene/',
    condition: (tab, product) => tab && !!product?.metadata?.geneId,
  },
  {
    label: 'Gene Symbol',
    valueKey: 'metadata.geneSymbol',
    condition: (tab, product) => tab && !!product?.metadata?.geneSymbol,
  },
  {
    label: 'Gene Aliases',
    valueKey: 'metadata.geneAliases',
    condition: (tab, product) => tab && !!product?.metadata?.geneAliases,
  },
  {
    label: 'Concentration',
    valueKey: 'concentration',
    format: (val) => (val ? `${val} mg/mL` : '-'),
  },
  {
    label: 'Buffer',
    format: (product) =>
      product?.buffer_molarity || product?.buffer
        ? `${product.buffer_molarity || ''}mM ${product.buffer || ''}`
        : '-',
  },
  {
    label: 'pH',
    valueKey: 'ph',
  },
  {
    label: 'Storage',
    format: (product) =>
      Array.isArray(product?.storage)
        ? product.storage.map((s) => `${s}°C`).join(', ')
        : '-',
  },
  {
    label: 'Dye Ex/Em',
    condition: (tab) => tab !== 'primary',
    format: (product) =>
      `${product?.excitation_wavelength || '-'} nm / ${product?.emission_wavelength || '-'} nm`,
  },
  {
    label: 'Extinction Coefficient',
    condition: (tab) => tab !== 'primary',
    valueKey: 'extinction_coefficient',
    format: (val) =>
      val ? (val.includes(',') ? val : Number(val).toLocaleString('en-US')) : '-',
  },
  {
    label: 'Molecular Weight',
    condition: (tab) => tab !== 'primary',
    valueKey: 'molecular_weight',
    format: (val) => (val ? `${val} Da` : '-'),
  },
  {
    label: 'Emission Color',
    condition: (tab) => tab !== 'primary',
    valueKey: 'emission_color',
  },
  {
    label: 'Unit Size',
    valueKey: 'unit_size',
    format: (val) => (val ? `${val} nm` : '100 µL'),
  }
];

export const getNestedValue = (obj, path) => {
  return path?.split('.').reduce((acc, key) => acc?.[key], obj);
};
